import React, { useState } from 'react'
import RevenueItem from '../../components/Leader/RevenueItem';

function TeamDataDetail({ teamDataGrouped }) {
  const [tab, setTab] = useState('member');

  const handleTab = (name) => {
    setTab(name);
  };

  return (
    <section className="group">
      <h2 className="tabs">
        <button className={tab === 'member' ? 'active' : ''} onClick={() => handleTab('member')}>Chi tiết doanh thu</button>
        <button className={tab === 'lead' ? 'active' : ''} onClick={() => handleTab('lead')}>Chi tiết lead</button>
      </h2>
      <div className="data-content section-card">
        {tab === 'member' && (
          <table>
            <thead>
              <tr>
                <th>STT</th>
                <th>Tên thành viên</th>
                <th>Số Order</th>
                <th>Doanh thu thực tế (đ)</th>
                <th>Hoa hồng (đ)</th>
              </tr>
            </thead>
            <tbody>
              {teamDataGrouped?.map((item, idx) => <RevenueItem key={idx} affiliateData={item} currentTab={tab} />)}
            </tbody>
          </table>
        )}
        {tab === 'lead' && (
          <table>
            <thead>
              <tr>
                <th>STT</th>
                <th>Tên thành viên</th>
                <th>Doanh thu thực tế (đ)</th>
                <th>Deal</th>
                <th>Lead</th>
                <th>Hoa hồng thực tế (đ)</th>
              </tr>
            </thead>
            <tbody>
              {teamDataGrouped?.map((item, idx) => <RevenueItem key={idx} affiliateData={item} currentTab={tab} />)}
            </tbody>
          </table>
        )}
      </div>
    </section>
  )
}

export default TeamDataDetail;
